import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "../reusble_components/loader";
import Footer from "./Footer";

import { AiOutlineLock, AiOutlineUser } from "react-icons/ai";
import { useParams } from "react-router-dom";
import { apiPostPut, apiPostPutPublic } from "../../api/api_methods";
import Mail from "../reusble_components/login/mail";
export default function RegisterDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const recuiter = queryParams.get("employer");
  const [warn, setWarn] = useState(false);

  const [loading, setloading] = useState(false);
  const [showTermAndConditions, setshowTermAndConditions] = useState(false);
  const [register, setRegister] = useState(false);
  const [enableSubmit, setEnableSubmit] = useState(false);

  const [newUserDetails, setnewUserDetails] = useState({});
  const [rcode, setRcode] = useState("");

  const [clusterId, setClusterId] = useState(null);
  useEffect(() => {
    const url = window.location.href;
    setClusterId(url.split("clusterId=")[1]);
  }, []);

  return (
    <>
      <div className="flex flex-col relative items-center justify-center mx-auto md:w-full lg:w-full w-[100%] h-screen bg-[#F8F2E9] gil-reg">
        <Loader loader={loading} />
        {/* <img
          src={getLogoForWhiteLabeling()}
          className=" w-[300px] md:w-[300px] lg:w-[400px] object-cover mb-5"
          alt="logo"
        /> */}

        <div className="flex flex-col gap-5 w-fit ">
          {/* <div className="flex items-center justify-start mb-[25%] md:mb-[15%] -mt-[10%] w-full cursor-pointer">
            <MdArrowBackIosNew className="text-black text-sm mr-1" />
            <span className="text-xs text-black font-bold">Back</span>
          </div> */}
          <h1 className="text-xl gil-bold ">
            Enter your Details <span className="text-[#ff6b00]">Register</span>
          </h1>

          <form
            className="flex flex-col gap-y-5 z-50"
            onSubmit={async (e) => {
              e.preventDefault();
              if (warn) {
                return;
              }
              setloading(true);
              let rolee = "647ce2e8c41bee677ea39fc4";
              if (
                recuiter != null &&
                recuiter != undefined &&
                recuiter != "null" &&
                recuiter != "undefined"
              ) {
                rolee = recuiter;
              }
              const body = {
                name: e.target.name.value,
                password: e.target.password.value,
                role: rolee,
                loginType: "email",
              };
              const response = await apiPostPutPublic(
                body,
                `/user/register-with-email/${id}`,
                "POST"
              );
              if (response.status === 200) {
                setloading(false);
                localStorage.setItem("register", true);
                localStorage.setItem(
                  "users",
                  JSON.stringify(response.body.data)
                );
                if (recuiter) {
                  navigate(
                    `/register?employer=${recuiter}&clusterId=${clusterId}`
                  );
                } else {
                  navigate(`/register?clusterId=${clusterId}`);
                }
              } else {
                setloading(false);
                alert(response.body.message);
              }
            }}
          >
            {/* <div className="flex items-center border-2 border-opacity-75 px-3 h-12 rounded-md">
              <AiOutlineUser className="text-2xl opacity-80 " />
              <input
                type="text"
                id="name"
                name="name"
                className=" bg-transparent px-2 py-2 outline-none rounded-lg placeholder:text-black placeholder:opacity-80 w-full  tracking-[3px] "
                placeholder="Enter your name"
              />
            </div> */}

            <div className=" ">
              <h1 className="w-50 h-2  mb-5 ml-2 font-bold ">
                {" "}
                {`Enter Your Name`}
              </h1>
              <Mail
                id="name"
                name="name"
                type="text"
                placeholder={`Enter Your Name`}
                icon={
                  <AiOutlineUser className="text-black text-lg mr-4 ml-1" />
                }
                required={true}
                // className="flex outline-none bg-white  "
              />
            </div>
            <div>
              {" "}
              <h1 className="w-50 h-2 ml-2 mb-5  font-bold">
                {" "}
                Create a Password
              </h1>
              <div className="flex items-center border bg-white rounded-lg p-2 w-80  mt-4">
                <AiOutlineLock className="text-black text-lg mr-4 ml-1 " />
                <input
                  type="password"
                  id="password"
                  name="password"
                  minLength={8}
                  className=" flex-1 outline-none bg-white "
                  placeholder="Password"
                  required={true}
                />
              </div>
            </div>
            <div>
              <h1 className=" h-2 ml-2 mb-5 font-bold"> Re-Enter Password</h1>
              <div className="flex items-center border bg-white rounded-lg p-2 w-80  mt-4">
                <AiOutlineLock className="text-black text-lg mr-4 ml-1" />
                <input
                  type="password"
                  name="confirmPassword"
                  className="flex-1 outline-none bg-white "
                  placeholder=" Password"
                  onChange={(e) => {
                    if (
                      e.target.value !==
                      document.getElementsByName("password")[0].value
                    ) {
                      setWarn(true);
                    } else {
                      setWarn(false);
                    }
                  }}
                  required={true}
                />
              </div>
            </div>

            {warn && (
              <span className="flex  whitespace-nowrap text-red-500 text-xs ">
                Your password and confirmation password do not match
              </span>
            )}
            <button
              type="submit"
              className="gil-reg text-lg bg-primary text-white px-4 py-2 rounded-lg shadow-md hover:shadow-lg focus:outline-none w-80"
            >
              Next
            </button>
          </form>
        </div>

        <span></span>

        {/* this is the UI button part starts */}

        {/* <div className="flex mt-5 bg-[#202126] cursor-pointer py-2 pl-10 pr-2 rounded-full relative justify-center" >
            <div className="bg-white mr-2 left-1 top-1 text-2xl absolute rounded-full p-[5px]">
            <FcGoogle className=""/>
            </div>
            <h1 className="text-base ml-2 text-white gil-med">Sign in with Google</h1>
            </div> */}
        {/* the UI  button part Ends */}
        {/* <HelpCenter position="/" /> */}
        {/* <button
        className="flex items-center bg-white border border-gray-300 rounded-xl px-6 py-4 shadow hover:shadow-md focus:outline-none"
        onClick={login}
        >
        <img
        src="https://github.com/spotmies/images/assets/63062130/6a19d364-9fae-4e55-9069-8b4e7924e124"
        className="object-cover h-6 w-6 mr-2"
        alt="logo"
        />
        <span>Continue with Google</span>
        </button> */}
        <div className="w-full absolute bottom-0">
          <Footer className="bg-blue-500 text-white p-6 flex items-end w-full absolute bottom-0 z-20" />
        </div>
      </div>
    </>
    // <div className="w-[95vw] h-[100vh] gil-reg">
    //   <div className="flex flex-row justify-center items-center h-full w-full ">
    //     <GoogleLogin
    //       onSuccess={(credentialResponse) => {
    //         console.log(credentialResponse);
    //         onSuccessLogin(credentialResponse);
    //       }}
    //       onError={() => {
    //         console.log("Login Failed");
    //         alert("Login Failed");
    //       }}
    //     />
    //   </div>
    // </div>
  );
}
